"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var StackHeaderTitle_exports = {};
__export(StackHeaderTitle_exports, {
  StackHeaderTitle: () => StackHeaderTitle,
  appendStackHeaderTitlePropsToOptions: () => appendStackHeaderTitlePropsToOptions
});
module.exports = __toCommonJS(StackHeaderTitle_exports);
var import_children = require("../../headless/children");
var import_platform = require("../../utils/platform");
var import_style = require("../../utils/style");
function StackHeaderTitle(_props) {
  return null;
}
Object.assign(StackHeaderTitle, {
  [import_children.NAVIGATOR_CONFIG]: true
});
function appendStackHeaderTitlePropsToOptions(options, props) {
  var flattenedStyle = (0, import_style.flattenStyle)(props.style);
  var flattenedLargeStyle = (0, import_style.flattenStyle)(props.largeStyle);
  var titleStyle = flattenedStyle ? {
    ...flattenedStyle,
    ...(flattenedStyle === null || flattenedStyle === void 0 ? void 0 : flattenedStyle.fontWeight) ? {
      fontWeight: (0, import_style.convertFontWeightToStringFontWeight)(flattenedStyle.fontWeight)
    } : {}
  } : void 0;
  var largeTitleStyle = flattenedLargeStyle ? {
    ...flattenedLargeStyle,
    ...(flattenedLargeStyle === null || flattenedLargeStyle === void 0 ? void 0 : flattenedLargeStyle.fontWeight) ? {
      fontWeight: (0, import_style.convertFontWeightToStringFontWeight)(flattenedLargeStyle.fontWeight)
    } : {}
  } : void 0;
  return {
    ...options,
    title: props.children,
    headerLargeTitleEnabled: props.large,
    // Large titles on iOS require headerTransparent for proper scroll behavior
    // Only set on iOS since headerLargeTitleEnabled is iOS-only
    ...props.large && import_platform.PLATFORM === "ios" && {
      headerTransparent: true
    },
    headerTitleAlign: flattenedStyle === null || flattenedStyle === void 0 ? void 0 : flattenedStyle.textAlign,
    // Only set styles when explicitly configured to avoid interfering with native defaults
    ...titleStyle && Object.keys(titleStyle).length > 0 && {
      headerTitleStyle: titleStyle
    },
    ...largeTitleStyle && Object.keys(largeTitleStyle).length > 0 && {
      headerLargeTitleStyle: largeTitleStyle
    }
  };
}
//# sourceMappingURL=StackHeaderTitle.js.map
